import axios, { AxiosResponse } from 'axios';

import { EZpusobPrevzati } from 'services/dokumenty/prikazy';

import { IStatniSpravaPutResp } from './odeslaniSluzby';

export interface IF45 {
    dlt?: boolean;
    dtvp: string;
    cval: string;
    pdcp: 'B' | 'S';
    actn: string;
    idco: string;
    zast: boolean;
    esm: boolean;
    bankucet: boolean;
    majucet: boolean;
    zpusob: EZpusobPrevzati;
    jmeno: string;
    prijmeni: string;
    rodnecislo: string;
    nazev: string;
    adma: string;
    mema: string;
    pscm: string;
    kost: string;
    email: string;
}

export interface IFSluzbyPutData {
    F9: {
        dtvp: string;
        idmb: string;
        rcma: string;
        cdac: string;
        cval: string;
        pjma: string;
        jmma: string;
        actn: string;
        idco: string;
        octg:
            | 1 // fyzická osoba
            | 2; // právnická osoba
        dtdv: string;
    };
    F15: { dtod: string; dtdo: string; cval: string };
    F16: { dtod: string; dtdo: string; cval: string };
    F17: { dtod: string; dtdo: string; idmb: string; cval: string; pjma: string; jmma: string; octg: 1 | 2 };
    F18: { dtod: string; dtdo: string; idmb: string; cval: string; pjma: string; jmma: string; octg: 1 | 2 };
    F20: {
        dtod: string;
        dtdo: string;
        idma: string;
        idmb: string;
        rcma: string;
        cdac: string;
        prbl: 0;
        actn: string;
        idco: string;
    };
    F24: { idmb: string; pjma: string; jmma: string; actn: string; idco: string; octg: 1 | 2 };
    F25: { dtod: string; dtdo: string; cval: string; actn: string; idco: string };
    F26: { dtod: string; dtdo: string; cval: string; actn: string; idco: string };
    F27: {
        dtod: string;
        dtdo: string;
        idmb: string;
        rcma: string;
        cdac: string;
        cval: string;
        actn: string;
        idco: string;
        pjma: string;
        jmma: string;
        octg:
            | 1 // fyzická osoba
            | 2; // právnická osoba
    };
    F28: {
        dtod: string;
        dtdo: string;
        idmb: string;
        rcma: string;
        cdac: string;
        cval: string;
        actn: string;
        idco: string;
        pjma: string;
        jmma: string;
        octg:
            | 1 // fyzická osoba
            | 2; // právnická osoba
    };
    F45: IF45;
    F50: { dtvp: string; idma: string; idmb: string; pjma: string; jmma: string; rosb: 'M' };
    F52: { dtod: string; dtdo: string; idma: string; rosb: 'M' };
    F53: { dtvp: string; idma: string; idmb: string; rcma: string; cdac: string; idsp: string };
    F56: { dtod: string; dtdo: string; rliv: string };
    F58: { dtod: string; dtdo: string; rliv: string };
    F1: { isin: string; datroz: string };
    F1A: { isin: string; datroz: string };
    F3: { dtvp: string };
}

export const FsluzbaPutApi = <T extends keyof IFSluzbyPutData>(sluzba: T, id: number, data: IFSluzbyPutData[T]) => {
    // sluzba napr F42, F18 etc
    return axios({
        method: 'PUT',
        url: `Sluzby/${id}/${sluzba}`,
        data: data
    }).then((resp: AxiosResponse<IStatniSpravaPutResp>) => resp.data);
};
